import {createContext, useContext, useEffect, useState} from 'react';
import axios from 'axios'
import {EnvContext} from './EnvContext';
import { UserContext } from './UserContext';

export const LeadsContext = createContext();

export const LeadsContextProvider = ({children}) => {
    const  {baseURL}  = useContext(EnvContext);
    const {user} = useContext(UserContext);

    const Axios = axios.create({ baseURL: baseURL });

    const [openLoadingModal, setOpenLoadingModal] = useState(false);

    const [singlePagination, setsinglePagination] = useState(true);
    const [activeLeadID, setActiveLeadID] = useState(null);
    const [leadData, setLeadData] = useState([]);
    const [archivedLeadData, setArchivedLeadData] = useState([]);
    const [ activeTab, setActiveTab]  = useState(true);

    const [leadFields,setLeadFields] = useState([]);

    const [emailScripts,setEmailScripts] = useState([]);

    const [textScripts,setTextScripts] = useState([]);

    const [agentData,setAgentData] = useState([]);

    const [leaderboard,setLeaderboard] = useState([]);    

    /*search stuff*/

    const [searchText,setSearchText] = useState("");

    const [filteredLeads, setFilteredLeads] = useState([]);
    const [filteredArchivedLeadData, setFilteredArchivedLeadData] = useState([]);

    const queryParameters = new URLSearchParams(window.location.search)
    const query_email = queryParameters.get("email");
    const query_vin = queryParameters.get("vin");


    useEffect(() => {

        var filteredResults = filterLeadData(leadData);
        
        if(filteredResults.length==0){
            filteredResults = leadData;
            setsinglePagination(true);
        }
        else{
            setsinglePagination(false);
        }

        setFilteredLeads(filteredResults);

        var filteredResults = filterLeadData(archivedLeadData);

        setFilteredArchivedLeadData(filteredResults);
    }, [searchText, leadData]);

    /*search stuff*/

    const filterLeadData = (leadData) => {
        var filteredResults;

        if(!searchText && query_email && query_vin) {
            filteredResults = leadData.filter(lead =>
                (lead.Vin_Number && lead.Vin_Number == query_vin) &&
                (lead.Email && lead.Email == query_email)
            );
        } else if (!searchText) {
            filteredResults = leadData;
        } else {
            filteredResults = leadData.filter(lead =>
                (lead.Vehicle_Year && (lead.Vehicle_Year + '').includes(searchText)) ||
                (lead.Vehicle_Make && lead.Vehicle_Make.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.Vin_Number && lead.Vin_Number.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.Email && lead.Email.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.First_Name && lead.Last_Name && (lead.First_Name.toLowerCase() + " " + lead.Last_Name.toLowerCase()).includes(searchText.toLowerCase()))
            );
        }

        return filteredResults;
    }


    const getLeads = async () => {
        setOpenLoadingModal(true);
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const values = {'agent_id':user.user_id,'admin':user.admin,'search_text':searchText};

            // console.log(values);

            const response = await Axios.post('bridge/leads/leads.php',values);
            // console.log(response.data);
            setOpenLoadingModal(false);

            var leads = [];
            var archived_leads = [];

            response.data.map((v,i) => {
                var name_parts = [];
                if(v.Vehicle_Year) name_parts.push(v.Vehicle_Year);
                if(v.Vehicle_Make) name_parts.push(v.Vehicle_Make);
                if(v.Vehicle_Model) name_parts.push(v.Vehicle_Model);
                if(v.Vehicle_Trim) name_parts.push(v.Vehicle_Trim);

                v.vehicle_name = name_parts.length > 0 ? name_parts.join(' ') : v.Vin_Number;

                var name_parts = [];
                if(v.First_Name) name_parts.push(v.First_Name);
                if(v.Last_Name) name_parts.push(v.Last_Name);

                v.full_name = name_parts.join(' ');

                if(v.archived) archived_leads.push(v);
                else leads.push(v);
            })
            setLeadData(leads);
            setArchivedLeadData(archived_leads);

        } catch (error) {
            // console.error('Error fetching leads:', error);
            setOpenLoadingModal(false);
            return {}; // Or handle error as needed
        }
    };

    const getLeadFields = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/lead_fields.php');

            // console.log(response.data);
            setLeadFields(response.data);


        } catch (error) {
            console.error('Error fetching lead fields:', error);
            return {}; //Or handle error as needed
        }
    };

    const getEmailScripts = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/email_scripts.php');

            // console.log(response.data);
            setEmailScripts(response.data);


        } catch (error) {
            console.error('Error fetching email scripts:', error);
            return {}; //Or handle error as needed
        }
    };

    const getTextScripts = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/text_scripts.php');

            // console.log(response.data);
            setTextScripts(response.data);


        } catch (error) {
            console.error('Error fetching text scripts:', error);
            return {}; //Or handle error as needed
        }
    };

    const getAgents = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/agents.php');

            // console.log(response.data);
            setAgentData(response.data);


        } catch (error) {
            console.error('Error getting agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const getLeaderboard = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/leaderboard.php');

            // console.log(response.data);
            setLeaderboard(response.data);


        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    const assignAgent = async (agent_id,email,vin) => {
        try {
            const values = {'agent_id':agent_id,'email':email,'vin':vin};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/assign_agent.php',values);

            // console.log(response.data);

        } catch (error) {
            console.error('Error assigning agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const updateTask = async (email,vin,schedule_id,completed) => {
        try {
            const values = {'email':email,'vin':vin,'schedule_id':schedule_id,'completed':completed};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_task.php',values);

            // console.log(response.data);

        } catch (error) {
            console.error('Error updating task:', error);
            return {}; //Or handle error as needed
        }
    };

    const completeNextTask = async (email,vin,type) => {
        try {
            const values = {'email':email,'vin':vin,'type':type};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/complete_next_task.php',values);

            // console.log(response.data);

            return response.data && response.data.success && response.data.task_id ? response.data.task_id : false;

        } catch (error) {
            console.error('Error completing next task:', error);
            return {}; //Or handle error as needed
        }
    };

    const archiveLead = async (thisLead) => {
        try {
            const response = await updateLeadData(thisLead.Email,thisLead.Vin_Number,'archived',1);

            if(response.success) getLeads();

        } catch (error) {
            console.error('Error archiving lead:', error);
            return {}; //Or handle error as needed
        }
    };

    const  updateLeadData = async (email,vin,field,value) => {
        try {
            const values = {'email':email,'vin':vin,'field':field,'value':value};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_lead_data.php',values);

            // console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error updating lead data:', error);
            return {}; //Or handle error as needed
        }
    };

    const addEmailScript = async (script_name, subject, script) => {
        try {
            const values = {'script_name':script_name,'subject':subject,'script':script};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_email_script.php',values);

            // console.log(response.data);

            if(response.data.success) getEmailScripts();

            return response.data;

        } catch (error) {
            console.error('Error adding email script:', error);
            return {}; //Or handle error as needed
        }
    }

    const addNoteWrapper = (leadData,title,subtitle,note) => {
        const values = {'email':leadData.Email,'vin':leadData.Vin_Number,'title':title,'subtitle':subtitle,'note':note};
        addNote(values);

        leadData.notes.push(values);
    }

    const addNote = async (values) => {
        try {
            
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_note.php',values);

            // console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error adding note:', error);
            return {}; //Or handle error as needed
        }
    };

    const addLead = async (values) => {
        try {

            if(user && user.first_name && user.last_name) values.user_full_name = user.first_name + " " + user.last_name;
            
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_lead.php',values);

            // console.log(response.data);

            if(response.data.success) getLeads();

            return response.data;

        } catch (error) {
            console.error('Error adding lead:', error);
            return {}; //Or handle error as needed
        }
    };

    const sendSms = async (formValues,leadData) => {
        try {
            // console.log(formValues);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/twilio/send_sms.php',formValues);

            addNoteWrapper(leadData,"Sent SMS","",formValues.message);

            return response.data;


        } catch (error) {
            console.error('Error sending text:', error);
            return {}; //Or handle error as needed
        }
    };

    const sendPlainTextEmail = async (formValues,leadData) => {
        try {
            // console.log(formValues);

            formValues.agent_name = leadData.agent_name;
            formValues.vin = leadData.Vin_Number;

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/email/send_plaintext.php',formValues);

            addNoteWrapper(leadData,"Plain Text Email","",formValues.message);

            return response.data;

        } catch (error) {
            console.error('Error sending text:', error);
            return {}; //Or handle error as needed
        }
    };

    const getAccutradeData = async (id) => {
        try {
            const values = {'id':id};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/accutrade_data.php',values);

            return response.data;

        } catch (error) {
            console.error('Error assigning agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const sendAccutradePDF = async (values) => {
        try {

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/accutrade_pdf.php',values);

            return response.data;

        } catch (error) {
            console.error('Error assigning agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const getImageType = (title) => {
        var image = "note-icon.svg";
        switch (title) {
            case "Agent Note": image = "note-icon.svg"; break;
            case "Sent SMS": image = "send-icon.svg"; break;
            case "Plain Text Email": image = "envlope-icon.svg"; break;
            case "Phone Call": image = "phone-icon.svg"; break;
            default: image = "note-icon.svg"; break;
        }

        return image;
    }

    useEffect(() => {
        if(user && user.username && user.username != 'publicuser') {
            getLeadFields();
            getLeads();
            getEmailScripts();
            getTextScripts();
            getAgents();
            getLeaderboard();
        }
        // console.log(user);
    },[user]);

    return (
        <>
            <LeadsContext.Provider value={{getLeads,openLoadingModal,singlePagination,setsinglePagination,activeTab,setActiveTab,searchText,setSearchText,filteredLeads,leadData,filteredArchivedLeadData,baseURL,setActiveLeadID,activeLeadID, emailScripts, textScripts, leadFields, agentData, sendSms, sendPlainTextEmail, assignAgent, updateTask, completeNextTask, updateLeadData, addNote, addEmailScript, addLead, leaderboard, archiveLead, getImageType, getAccutradeData, sendAccutradePDF}}>
                {children}
            </LeadsContext.Provider>
        </>
    );
}

export default LeadsContextProvider